import React from "react";
import { Card, Button } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars-2";
import { formatDate } from "../../NewSales/utils/dateUtils";
import { useCurrency } from "../../../../_helper/CurrencyContext";

const PrescriptionSummary = ({
    t,
    selectedPatient,
    recentPrescriptions = [],
    onClose,
    onSelectPrescription,
    isHospitalConnected,
    isWalkingCustomer = false,
    walkingCustomerName
}) => {
    const { getCurrencySymbol } = useCurrency();

    if (!recentPrescriptions.length) return null;

    const customerDisplayName = isWalkingCustomer
        ? walkingCustomerName
        : selectedPatient?.full_name || selectedPatient?.patient_name;

    return (
        <Card className="mb-3 prescriptions-card">
            <Card.Header
                style={{
                    position: "relative",
                    padding: "10px 15px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <h6 style={{ margin: 0, fontWeight: 600 }}>
                    {t("Recent Purchases for")} {customerDisplayName}
                </h6>

                <Button
                    variant="link"
                    className="p-0"
                    style={{ fontSize: "1.2rem", lineHeight: 1, color: "#333" }}
                    onClick={onClose}
                    aria-label={t("Close prescriptions card")}
                >
                    &times;
                </Button>
            </Card.Header>

            <Card.Body>
                <Scrollbars
                    autoHide
                    style={{ height: "400px", minHeight: '180px' }}
                    universal
                    renderTrackHorizontal={(props) => <div {...props} style={{ display: "none" }} />}
                >
                    {recentPrescriptions.map((sale, index) => {
                        const hasReturnedItems =
                            sale.isReturn ||
                            sale.salesHistory?.some(h => h.isReturn);
                        return (
                            <div
                                key={index + sale._id}
                                className="border-bottom prescription-item py-2 px-1"
                                onClick={() => onSelectPrescription(sale)}
                                style={{
                                    cursor: "pointer",
                                    transition: "background-color 0.2s",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f8f9fa")}
                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                            >
                                <div className="d-flex justify-content-between align-items-center">
                                    <strong>{formatDate(sale.createdAt)}</strong>
                                    {hasReturnedItems && (
                                        <span className="badge bg-danger ms-auto">{t("Returned")}</span>
                                    )}
                                    <span className="badge bg-secondary">{sale.salesNumber}</span>
                                </div>
                                {/* {sale.patientName && (
                                    <p className="mb-0 mt-1 ms-2 text-muted small">
                                        {t("Customer")}: {sale.patientName}
                                    </p>
                                )} */}
                                <p className="mb-0 mt-1 ms-2 text-muted small">
                                    {t("Items")}: <b>{sale.itemCount}</b> | {t("Total")}: <b>{getCurrencySymbol(sale.currencyType)}{sale.totalPaid.toFixed(2)}</b>
                                </p>

                                {/* display up to 2 medicines */}
                                <ul className="small text-muted mb-0 mt-1 ms-3">
                                    {sale.salesHistory?.slice(0, 2).map((item, i) => (
                                        <li className="tw-flex tw-items-center tw-gap-2" key={i + item.brandName}>
                                            {i + 1}. {item.brandName || item.medicineName || t("Unknown Medicine")}
                                            <span className="tw-w-[25px] tw-h-[25px] tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-200 tw-text-gray-600 tw-font-bold">
                                                {item.medicineQunatity}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )
                    })}
                </Scrollbars>
            </Card.Body>
        </Card>
    );
};

export default PrescriptionSummary;